"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withHtml = exports.insertHtml = void 0;
var react_1 = __importStar(require("react"));
var Ant = __importStar(require("antd"));
var styled_components_1 = __importDefault(require("styled-components"));
var slate_1 = require("slate");
var sanitize_html_1 = __importDefault(require("sanitize-html"));
function _sanitizeHtml(value) {
  var sanitizeOptions = {
    allowedTags: ['address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup', 'main', 'nav', 'section', 'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'main', 'ol', 'p', 'pre', 'ul', 'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn', 'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr', 'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'img', 'iframe'],
    allowedAttributes: {
      '*': ['href', 'align', 'alt', 'center', 'bgcolor', 'style'],
      img: ['src'],
      iframe: ['src', 'width', 'height', 'style', 'loading', 'allowfullscreen', 'referrerpolicy', 'frameborder', 'scrolling', 'allowtransparency']
    },
    allowedSchemesAppliedToAttributes: ['href', 'src', 'cite'],
    allowedIframeHostnames: ['www.google.com', 'www.instagram.com', 'www.facebook.com']
  };
  var out = sanitize_html_1.default(value, sanitizeOptions);
  console.log('dbg', out);
  return out;
}
function isHtml(value) {
  var re = /<(“[^”]*”|'[^’]*’|[^'”>])*>/gm;
  return re.test(value);
}
var insertHtml = function (editor, value) {
  var text = {
    text: ''
  };
  var image = {
    type: 'html',
    value: _sanitizeHtml(value),
    children: [text]
  };
  slate_1.Transforms.select(editor, editor._onBlurSelection);
  slate_1.Transforms.insertNodes(editor, image);
  // workaround, let user can select pure text rather than the image block
  var emptyTextNode = {
    type: 'p',
    children: [{
      text: ''
    }]
  };
  slate_1.Transforms.insertNodes(editor, emptyTextNode);
};
exports.insertHtml = insertHtml;
var withHtml = function (editor) {
  var insertData = editor.insertData,
    isVoid = editor.isVoid;
  editor.isVoid = function (element) {
    return element.type === 'html' ? true : isVoid(element);
  };
  editor.insertData = function (data) {
    var text = data.getData('text/plain');
    if (isHtml(text)) {
      insertHtml(editor, text);
    } else {
      insertData(data);
    }
  };
  return editor;
};
exports.withHtml = withHtml;
function HtmlModal(props) {
  var _a = react_1.useState(''),
    value = _a[0],
    setValue = _a[1];
  var visible = props.visible,
    onCancel = props.onCancel,
    onInsert = props.onInsert;
  return react_1.default.createElement(Ant.Modal, {
    className: "custom-modal",
    title: "\u63D2\u5165HTML",
    visible: visible,
    onCancel: onCancel,
    onOk: function () {
      if (!isHtml(value)) {
        return Ant.message.error('需填入正確html');
      }
      onCancel();
      onInsert(value);
      setValue('');
    },
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88",
    width: "90%"
  }, react_1.default.createElement(Wrapper, null, react_1.default.createElement("div", {
    className: "left"
  }, react_1.default.createElement("div", {
    className: "block"
  }, react_1.default.createElement("p", null, "\u2705 \u652F\u63F4 a (\u9023\u7D50) \u3001 img (\u5716\u7247)\u3001\u53CA\u5176\u4ED6\u6587\u5B57\u985E\u3001\u5340\u584A\u985E\u7684 html")), react_1.default.createElement("div", {
    className: "block"
  }, react_1.default.createElement("p", null, "\u652F\u63F4 iframe "), react_1.default.createElement("p", null, "\u2705 google, facebook, instagram"), react_1.default.createElement("p", null, "\uD83D\uDEAB \u5176\u9918\u7DB2\u7AD9\u66AB\u4E0D\u652F\u63F4"), react_1.default.createElement("p", null, "instagram \u8ACB\u52FF\u9EDE\u9078\u5B98\u65B9\u7684\u5D4C\u5165\u78BC\uFF0C\u8ACB", react_1.default.createElement("b", null, "\u8907\u88FD\u9023\u7D50"), "\u4E26\u5C07/p/\u5F8C\u9762\u7684\u7DE8\u865F\u8986\u84CB\u6389\u4EE5\u4E0B\u7BC4\u4F8B\u4E2D\u7684 src \u7DE8\u865F\u7684\u5340\u6BB5"), react_1.default.createElement("blockquote", null, "<iframe src=\"https://www.instagram.com/p/CGnw1SIhPs1/embed\" width=\"400\" height=\"480\" frameborder=\"0\" scrolling=\"no\" allowtransparency=\"true\"></iframe>")), react_1.default.createElement("div", {
    className: "block"
  }, react_1.default.createElement("p", null, "\uD83D\uDEAB \u70BA\u8003\u91CF\u5B89\u5168\u554F\u984C\uFF0C\u4E0D\u652F\u63F4 script \u8173\u672C\u985E\u578B\u7684 html "))), react_1.default.createElement("textarea", {
    placeholder: "\u586B\u5165HTML",
    value: value,
    onChange: function (e) {
      return setValue(e.target.value);
    }
  })));
}
exports.default = HtmlModal;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px;\n  display: flex;\n  align-items: stretch;\n  gap: 10px;\n\n  & > textarea {\n    flex: 1;\n    width: 100%;\n    min-height: 300px;\n    border: solid 1px #eee;\n    outline: solid 1px #e5f6fd;\n    padding: 5px 8px;\n  }\n\n  & > .left {\n    flex: 1;\n\n    & > .block {\n      background-color: #eee;\n      border-radius: 6px;\n      padding: 5px 8px;\n      margin-bottom: 10px;\n\n      & > blockquote {\n        padding: 3px 8px;\n        font-size: 12px;\n        color: #707070;\n        font-family: 'Courier New', monospace;\n        word-break: break-all;\n      }\n    }\n  }\n"], ["\n  padding: 10px;\n  display: flex;\n  align-items: stretch;\n  gap: 10px;\n\n  & > textarea {\n    flex: 1;\n    width: 100%;\n    min-height: 300px;\n    border: solid 1px #eee;\n    outline: solid 1px #e5f6fd;\n    padding: 5px 8px;\n  }\n\n  & > .left {\n    flex: 1;\n\n    & > .block {\n      background-color: #eee;\n      border-radius: 6px;\n      padding: 5px 8px;\n      margin-bottom: 10px;\n\n      & > blockquote {\n        padding: 3px 8px;\n        font-size: 12px;\n        color: #707070;\n        font-family: 'Courier New', monospace;\n        word-break: break-all;\n      }\n    }\n  }\n"])));
var templateObject_1;